import { earlierHomeContactLabel, homeContactTargetKey } from './homeContactRequest';
const rendered = new WeakMap();
/** Patch only changed content: an unchanged blur event must not replace the focused button. */
export function renderHomeContactRequests(row, current, match, query, lookupStatus) {
    const key = JSON.stringify({ current, match, query, lookupStatus });
    if (rendered.get(row) === key)
        return;
    rendered.set(row, key);
    const document = row.ownerDocument;
    const hadFocus = row.contains(document.activeElement);
    const focusedAction = Array.from(row.querySelectorAll('button')).find(node => node === document.activeElement)?.dataset.action;
    row.tabIndex = -1;
    row.replaceChildren();
    const line = (value, status = false) => {
        const node = document.createElement('span');
        node.textContent = value;
        if (status) {
            node.setAttribute('role', 'status');
            node.setAttribute('aria-live', 'polite');
        }
        row.appendChild(node);
    };
    const button = (label, action, disabled, accessibleLabel = label) => {
        const node = document.createElement('button');
        node.type = 'button';
        node.className = 'composer-directory-add';
        node.textContent = label;
        node.dataset.action = action;
        node.disabled = disabled;
        node.setAttribute('aria-label', accessibleLabel);
        if (action === 'add-composer-directory-contact')
            node.setAttribute('data-composer-directory-add', '');
        row.appendChild(node);
    };
    const { pending, review, status, busy, ready } = current;
    const disabled = busy || !ready;
    if (pending) {
        line(earlierHomeContactLabel(pending));
        if (pending.input?.kind === 'manual') {
            const draft = pending.input.contact;
            line(`Earlier draft: ${draft.name}`);
            line(`Organization: ${draft.organization || 'None'}`);
            line(`Notes: ${draft.notes || 'None'}`);
            line(`Favorite: ${draft.isFavorite ? 'Yes' : 'No'} · Groups: ${draft.groupIds?.length || 0} selected`);
        }
        if (pending.input?.kind === 'request')
            button('Retry original contact request', 'retry-composer-contact-request', disabled);
        button('Check earlier save', 'resolve-composer-contact-request', disabled);
    }
    else if (match) {
        line(match.existingContact ? match.name : `${match.name} · not in your contacts`);
        const key = homeContactTargetKey(query, match);
        if (key && current.sentTarget !== key)
            button('Send contact request', 'add-composer-directory-contact', disabled, `Send ${match.name} a contact request`);
    }
    if (review) {
        line('Saved contact details');
        line(`Name: ${review.name}`);
        line(`Organization: ${review.organization || 'None'}`);
        line(`Notes: ${review.notes || 'None'}`);
        line(`Favorite: ${review.isFavorite ? 'Yes' : 'No'}`);
        line(`Groups: ${review.groupNames.join(', ') || 'None'}`);
        button('Use saved contact details', 'accept-composer-contact-details', disabled);
    }
    if (status)
        line(status, true);
    if (lookupStatus)
        line(lookupStatus, true);
    if (!ready && !busy)
        button('Check earlier saves again', 'refresh-composer-contact-requests', false);
    row.classList.toggle('composer-route-hidden', !row.childNodes.length);
    if (hadFocus) {
        const buttons = Array.from(row.querySelectorAll('button'));
        (buttons.find(node => node.dataset.action === focusedAction && !node.disabled) || buttons.find(node => !node.disabled) || row).focus({ preventScroll: true });
    }
}
